import React from "react";
import { stopNativeLiveLocation } from "../../../components/liveLocation/nativeBridge";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LogoutDialog = ({ open, setOpen }) => {
  const handleCancel = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    stopNativeLiveLocation();
    const themeMode = localStorage.getItem("themeMode");
    localStorage.clear();
    if (themeMode) localStorage.setItem("themeMode", themeMode);
    window.location.reload();
  };

  return (
    <Dialog
      TransitionComponent={Transition}
      keepMounted
      PaperComponent={(props) => (
        <Paper
          style={{
            position: "absolute",
            bottom: 0,
            margin: "0px",
            width: "100%",
            maxWidth: "unset",
            direction: "rtl",
            borderRadius: "24px 24px 0px 0px",
          }}
          {...props}
        />
      )}
      onClose={handleCancel}
      open={open}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontSize: "19px", color: "text.primary" }}>
          خروج از حساب کاربری
        </Typography>
        <IconButton
          onClick={handleCancel}
          sx={{ color: "#71717A", padding: 0 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText color="text.secondary">
          آیا تمایل به خروج از حساب کاربری خود را دارید؟
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ direction: "rtl", p: "0px 24px 16px 24px" }}>
        <Button
          onClick={handleCancel}
          variant="outlined"
          sx={{
            marginLeft: "16px",
            width: "50%",
          }}
          size="large"
        >
          انصراف
        </Button>
        <Button
          size="large"
          onClick={handleLogout}
          variant="contained"
          sx={{
            margin: "0px !important",
            width: "50%",
            backgroundColor: "#f44336",
            "&:hover": { backgroundColor: "#d32f2f" },
          }}
        >
          خروج
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutDialog;
